import day from 'utils/day';

const todayDate = day();

export const loggedFoodData = [
  {
    id: 1478,
    name: 'bacon',
    date: todayDate.format('YYYY-MM-DD'),
    type: 'Breakfast',
    quantity: '3',
    unit: 'slices',
    calories: '161',
    protein: 12,
    fat: 12,
    carbs: 1,
    fiber: 0,
    brandName: null,
    fraction: null,
    nixItemId: null,
    migratedAt: null,
    saturatedFat: 7,
    transFat: 2,
    cholesterol: 34,
    sugar: 15,
    sodium: 581,
    patientId: 200,
  },
];

export const loggedFood = {
  migratedAt: false,
  graphData: {},
  oneDayGraph: {},
  data: loggedFoodData,
};
export const createAllFood = {
  migratedAt: false,
  graphData: {
    [todayDate.format('YYYY-MM-DD')]: {
      fat: 22,
      carbs: 1,
      protein: 12,
      fiber: 0,
      calories: 161,
      saturatedFat: 7,
      transFat: 2,
      sodium: 581,
      sugar: 15,
      cholesterol: 34,
      fatPercent: 68,
      carbsPercent: 3,
      proteinPercent: 29,
    },
  },
  oneDayGraph: {},
  data: {
    [todayDate.format('YYYY-MM-DD')]: {
      Breakfast: loggedFoodData,
    },
  },
};
export const loggedRecipeData = [
  {
    id: 5409,
    name: 'Soup',
    date: '2021-11-22',
    time: null,
    type: 'Breakfast',
    quantity: '1',
    unit: 'serving',
    thumbImgUrl: null,
    highImageUrl: null,
    calories: 523,
    protein: 30,
    fat: 20,
    carbs: 55,
    fiber: 6,
    brandName: null,
    fraction: null,
    nixItemId: null,
    migratedAt: null,
    saturatedFat: 4,
    transFat: 0,
    cholesterol: 94,
    sugar: 3,
    sodium: 388,
    satisfaction: null,
    createdAt: '2021-11-22T19:47:58.671Z',
    updatedAt: '2021-11-22T19:47:58.671Z',
    createdBy: null,
    updatedBy: null,
    patientRecipeId: 1,
    isPatientRecipe: true,
    patientId: 109,
  },
];
export const loggedRecipe = {
  migratedAt: false,
  graphData: {
    [todayDate.format('YYYY-MM-DD')]: {
      fat: 39,
      carbs: 79,
      protein: 57,
      fiber: 8,
      calories: 895,
      saturatedFat: 10,
      transFat: 0,
      sodium: 1305,
      sugar: 6,
      cholesterol: 175,
      fatPercent: 39,
      carbsPercent: 35,
      proteinPercent: 26,
    },
  },
  oneDayGraph: {},
  data: {
    [todayDate.format('YYYY-MM-DD')]: {
      Breakfast: loggedRecipeData,
    },
  },
};
export const mockFood = [
  {
    name: 'Naturally Hardwood Smoked Bacon',
    photo: {
      thumb: 'https://nutritionix-api.s3.amazonaws.com/5e2beb1bded6acd81b4281ce.jpeg',
    },
    brandName: 'Oscar Mayer Bacon',
    servingWeight: 19,
    nixItemId: '51d2fb64cc9bff111580dc50',
    unit: 'skillet cooked slices',
    quantity: 2,
    calories: 90,
  },
  {
    name: 'bacon',
    unit: 'slices',
    quantity: 3,
    photo: {
      thumb: 'https://nix-tag-images.s3.amazonaws.com/11_thumb.jpg',
    },
    servingWeight: 34.5,
    calories: 165,
  },
];
export const mockFoodChangedUnit = {
  name: 'bacon',
  unit: 'cup',
  quantity: 2,
  photo: {
    thumb: 'https://nix-tag-images.s3.amazonaws.com/11_thumb.jpg',
  },
  servingWeight: 80,
  calories: 748.8000000000001,
  protein: 54.272000000000006,
  fat: 60.78191304347826,
  carbs: 2.72,
  fiber: 64.92753623188406,
  saturatedFat: 19.14249275362319,
  transFat: 0.2304927536231884,
  cholesterol: 158.4,
  sugar: 69.56521739130434,
  sodium: 2694.4,
};

export const mockNutrients = {
  brandName: null,
  calories: 161.46,
  carbs: 0.5865,
  cholesterol: 34.155,
  fat: 13.1061,
  fiber: 14,
  highImageUrl: 'https://nix-tag-images.s3.amazonaws.com/11_highres.jpg',
  name: 'bacon',
  nixItemId: null,
  protein: 11.7024,
  quantity: 3,
  saturatedFat: 4.1276,
  servingWeight: 34.5,
  sodium: 580.98,
  sugar: 15,
  thumbImgUrl: 'https://nix-tag-images.s3.amazonaws.com/11_thumb.jpg',
  transFat: 0.0497,
  unit: 'slices',
  options: [
    {
      serving_weight: 11.5,
      measure: 'slice',
      seq: 1,
      qty: 1,
    },
    {
      serving_weight: 34.5,
      measure: 'side',
      seq: 80,
      qty: 1,
    },
    {
      serving_weight: 34.5,
      measure: 'slices',
      seq: 81,
      qty: 3,
    },
    {
      serving_weight: 80,
      measure: 'cup',
      seq: 82,
      qty: 1,
    },
    {
      serving_weight: 100,
      measure: 'g',
      seq: null,
      qty: 100,
    },
    {
      serving_weight: 28.3495,
      measure: 'wt. oz',
      seq: null,
      qty: 1,
    },
    {
      serving_weight: 1.67,
      measure: 'tsp',
      seq: 101,
      qty: 1,
    },
    {
      serving_weight: 5,
      measure: 'tbsp',
      seq: 102,
      qty: 1,
    },
  ],
};
export const editedFood = {
  id: 1478,
  name: 'bacon',
  date: todayDate.format('YYYY-MM-DD'),
  time: null,
  type: 'Breakfast',
  quantity: '2',
  unit: 'cup',
  thumbImgUrl: 'https://nix-tag-images.s3.amazonaws.com/11_thumb.jpg',
  highImageUrl: 'https://nix-tag-images.s3.amazonaws.com/11_highres.jpg',
  calories: '749',
  protein: 54,
  fat: 56,
  carbs: 3,
  fiber: 0,
  brandName: null,
  fraction: null,
  nixItemId: null,
  migratedAt: null,
  saturatedFat: 19,
  transFat: 2,
  cholesterol: 158,
  sugar: 15,
  sodium: 2694,
  updatedBy: 10,
  patientId: 200,
};
export const foodLogs = [
  {
    id: 1478,
    name: 'bacon',
    brandName: null,
    quantity: '3',
    unit: 'slices',
    calories: '161',
    protein: 12,
    fat: 22,
    carbs: 1,
    fiber: 0,
    saturatedFat: 7,
    cholesterol: 34,
    sugar: 15,
    sodium: 581,
    transFat: 2,
    nixItemId: null,
    date: todayDate.format('YYYY-MM-DD'),
    time: null,
    type: 'Breakfast',
    patientId: 200,
    fraction: null,
    migratedAt: null,
    createdBy: null,
    updatedBy: null,
  },
];
